<template>
<v-container fluid>
    <router-link :to="{name: 'crossOrgTab', params: {tab: 'orgs'}}">&lt;&lt;Back to Organizations List</router-link>
    <p></p>

            <v-layout wrap>
              <v-flex xs10><h3>Organization: {{activeOrg.name}}</h3></v-flex>
              <v-flex xs2><v-btn text color="orange" :disabled="activeOrg.sla!==100" @click="purge">Purge Org</v-btn></v-flex>
            </v-layout>
            
            <v-form v-model="validOrg" ref="orgeditform" @submit.prevent>

            <v-container grid-list-sm>
            <v-layout wrap>
                <v-flex xs12 sm5 md5>
                <v-text-field v-model="activeOrg.name" :rules="[rules.required]" label="Name" @input="valueChanged"></v-text-field>
                </v-flex>
                <v-flex sm2 md2></v-flex>
                <v-flex xs12 sm5 md5>
                <v-text-field v-model="activeOrg.domainName" label="Domain" @input="valueChanged"></v-text-field>
                </v-flex>
                <v-flex xs12 sm5 md5>
                  <v-autocomplete
                      :autofocus="false"
                      autocomplete="off"
                      v-model="activeOrg.timeZone"
                      :items="timeZEntries"
                      label="Timezone"
                      @input="valueChanged"
                      :rules="[rules.required]"
                    ></v-autocomplete>
                </v-flex>
                <v-flex sm2 md2></v-flex>
                <v-flex xs12 sm5 md5>
                  <v-select v-model="activeOrg.sla" :items="slas" label="SLA" @input="valueChanged"></v-select>
                </v-flex>
                <v-flex xs12>
                <v-textarea v-model="activeOrg.miscData" label="Misc Data" rows=2 @input="valueChanged"></v-textarea>
                </v-flex>
                <v-flex xs5>
                <v-select
                    v-model="selectedProducts"
                    :items="allProducts"
                    attach
                    label="Products"
                     @input="valueChanged"
                    multiple clearable small-chips deletable-chips
                  ></v-select>

                </v-flex>
                <v-flex xs2></v-flex>
                <v-flex xs5>
                <v-select
                    v-model="selectedFeatures"
                    :items="allFeatures"
                    attach
                    multiple clearable small-chips deletable-chips
                     @input="valueChanged"
                    label="Features"
                  ></v-select>

                </v-flex>
                <v-flex xs5>
                  <span class="subheading">Available Modules ({{filteredModules(activeOrg).length}})</span>
                  <v-list three-line dense style="height:250px; overflow-y:scroll;border:solid grey 1px;">
                      <v-list-item v-for="rpt in filteredModules(activeOrg)" :key="rpt.id">
                      <v-list-item-action>
                          <v-checkbox @change="availableCheckChanged(rpt)"
                          ></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content style="margin-left: -25px;">
                          <v-list-item-title>{{rpt.displayName}}</v-list-item-title>
                          <v-list-item-subtitle>{{rpt.description}}</v-list-item-subtitle>
                      </v-list-item-content>
                      </v-list-item>
                  </v-list>
                </v-flex>
                <v-flex xs2 style="text-align:center;">
                  <br />

                  <v-tooltip bottom>
                    <template v-slot:activator="{on, attrs}">
                      <v-btn icon @click="moveSelectedAvailableToAssigned(activeOrg)"
                           :disabled="selectedAvailable.length===0">
                          <v-icon>fa-angle-right</v-icon>
                      </v-btn>
                    </template>
                    <span>Assign selected modules</span>
                  </v-tooltip>
                  <br />

                  <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                      <v-btn icon @click="moveAllAvailableToAssigned(activeOrg)">
                          <v-icon>fa-angle-double-right</v-icon>
                      </v-btn>
                    </template>
                    <span>Assign all modules</span>
                  </v-tooltip>
                  <br />

                  <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                      <v-btn icon @click="unAssignSelected(activeOrg)"
                          :disabled="selectedAssigned.length===0">
                        <v-icon>fa-angle-left</v-icon>
                      </v-btn>
                    </template>
                    <span>Unassign selected modules</span>
                  </v-tooltip>
                  <br />

                  <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                      <v-btn icon @click="unAssignAll(activeOrg)">
                          <v-icon>fa-angle-double-left</v-icon>
                      </v-btn>
                    </template>
                    <span>Unassign all modules</span>
                  </v-tooltip>
                  <br />

                </v-flex>
                <v-flex xs5>

                    <span class="subheading">Assigned Modules ({{activeOrg.enabledModules.length}})</span>
                <v-list three-line dense style="height:250px; overflow-y:scroll;border:solid grey 1px;">
                    <v-list-item v-for="rpt in activeOrg.enabledModules" :key="rpt.id+rerender-rerender">
                    <v-list-item-action>
                        <v-checkbox @change="assignedCheckChanged(rpt.id)"
                        ></v-checkbox>
                    </v-list-item-action>

                    <v-list-item-content style="margin-left: -25px;">
                        <v-list-item-title>{{rpt.displayName}}</v-list-item-title>
                        <v-list-item-subtitle>{{rpt.description}}</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                </v-list>
                </v-flex>
                <v-flex xs12>

                  <v-btn text color="orange" :disabled="!changed" @click="reset">Reset</v-btn>
                  <v-btn text color="orange" :disabled="!changed || !validOrg" @click="save">Save</v-btn>
                </v-flex>
            </v-layout>
            </v-container>
            </v-form>
</v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import {TZ_DISPLAY_MAP_ORG} from '../../models/timezone.model'
import Utility from './utility'
export default {
  data(){
      return {
        changed: false,
        showBasic: true,
        showConfig: false,
        showFeatures: false,
        orgDetails: false,
        validOrg: false,
        rules: {
            required: value => !!value || 'Required.'
        },
        timeZEntries: Object.entries(TZ_DISPLAY_MAP_ORG).map((a,b) => {return {text:a[1], value:a[0]}}),
        originalItem: null,
        slas: [
          {text: '', value: 0},
          {text: 'Paid', value: 1},
          {text: 'Trial', value: 10},
          {text: 'Self-Service Trial', value: 11},
          {text: 'Expired', value: 100},
          {text: 'CCO', value: 1000}
        ],
        selectedAvailable: [],
        selectedAssigned: [],
        allProducts: [
          {text: 'vAnalytics', value: 'VAN'},
          {text: 'vControl', value: 'VCR'},
          {text: 'Customer App', value: 'CAP'}
        ],
        selectedProducts: [],
        allFeatures: [
          {text: 'Collection Agent', value: 'collectionAgent'},
          {text: 'Module Access Control per User', value: 'moduleAccessPerUser'},
          {text: 'Endpoint Auto Feed', value: 'endpointAutoFeed'},
          {text: 'Access Group', value: 'accessGroup=true'},
          {text: 'Default Module Disabled', value: 'defaultModuleDisabled'}
        ],
        selectedFeatures: [],
        rerender: 0
      }
  },
  computed: {
    ...mapGetters('crossorg', {
        activeOrg: 'activeOrg',
        reportModules: 'getReportModules'
    })
  },
  async created () {
    await this.$store.dispatch('crossorg/getReportModules')
    let org = await this.$store.dispatch("crossorg/getOrganization", this.$route.params.id);
    this.originalItem = _.cloneDeep(org)
    this.selectedProducts = _.split(this.activeOrg.featureTxt, ',')
    this.selectedFeatures = _.split(this.activeOrg.config, ';')
  },
  methods: {
    formatDateTime(val) {
      return moment(val).format('MM/DD/YYYY, h:mm:ss a')
    },
    async save () {

        this.activeOrg.featureTxt = _.join(this.selectedProducts)
        this.activeOrg.config = _.join(this.selectedFeatures, ';')

        let org = await this.$store.dispatch("crossorg/updateOrg", {org: this.activeOrg,
                                patchObject: Utility.createPatchObject(this.originalItem, this.activeOrg)})

        if (org === null) {
          alert('An error occurred. Please see browser console.')
        } else {
          this.originalItem = _.cloneDeep(org)
          this.changed = false
          alert('Changes have been saved.')
        }
    },
    reset() {
        this.$store.dispatch("crossorg/resetActiveOrg")
        this.selectedProducts = _.split(this.activeOrg.featureTxt, ',')
        this.selectedFeatures = _.split(this.activeOrg.config, ';')
        this.changed = false
    },
    async purge() {
      if (confirm("Purging an Org will delete user and preferences data. Continue?")) {
        let org = await this.$store.dispatch("crossorg/purgeOrg", this.activeOrg.id)
      }
    },
    filteredModules(org) {
      const ids = _.map(org.enabledModules, 'id')
      return _.reject(this.reportModules, (mod) => { return ids.includes(mod.id)})
    },
    availableCheckChanged(rptModule) {
      this.changed = true
      let id = rptModule.id
      if (!!_.find(this.selectedAvailable, {id})) {
        _.remove(this.selectedAvailable, {id})
      } else {
        this.selectedAvailable.push(rptModule)
      }
    },
    assignedCheckChanged(id) {
      this.changed = true
      if (this.selectedAssigned.includes(id)) {
        _.pull(this.selectedAssigned, id)
      } else {
        this.selectedAssigned.push(id)
      }
    },
    moveSelectedAvailableToAssigned(org) {
      this.changed = true
      for(let i=0; i<this.selectedAvailable.length; i++) {
        org.enabledModules.push(this.selectedAvailable[i])
      }
      if (this.selectedAvailable.length) {
        this.selectedAvailable.splice(0, this.selectedAvailable.length)
      }
    },
    unAssignSelected(org) {
      this.changed = true
      for(let i=0; i<this.selectedAssigned.length; i++) {
        _.remove(org.enabledModules, {id: this.selectedAssigned[i]})
      }
      this.rerender++
      if (this.selectedAssigned) {
        this.selectedAssigned.splice(0, this.selectedAssigned.length)
      }
    },
    moveAllAvailableToAssigned(org) {
      this.changed = true
      const ids = _.map(org.enabledModules, 'id')
      for(let i=0; i<this.reportModules.length; i++) {
        if (!ids.includes(this.reportModules[i].id)) {
          org.enabledModules.push(this.reportModules[i])
        }
      }
      if (this.selectedAvailable.length) {
        this.selectedAvailable.splice(0, this.selectedAvailable.length)
      }
    },
    unAssignAll(org) {
      this.changed = true
      if (org.enabledModules.length) {
        org.enabledModules.splice(0, org.enabledModules.length)
        this.rerender++
      }
      if (this.selectedAssigned) {
        this.selectedAssigned.splice(0, this.selectedAssigned.length)
      }
    },
    valueChanged() {
      this.changed = true
      this.$refs['orgeditform'].validate()
    }
  }
}
</script>
